import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';

import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';
import Loader from 'components/Loader';
import ScrollTop from 'components/ScrollTop';
import GlobalMeetingAlert from 'components/GlobalMeetingAlert';
import { AccessControlProvider, AccessViewGuard } from 'contexts/AccessControlContext';
import { useMeeting } from 'contexts/MeetingContext';
import MeetingRoom from 'modules/meetings/components/meeting-room/MeetingRoom';

import { handlerDrawerOpen, useGetMenuMaster } from 'api/menu';

export const HEADER_HEIGHT = 48;
export const RAIL_WIDTH = 68;
export const PANEL_WIDTH = 220;

export default function DashboardLayout() {
  const { menuMasterLoading } = useGetMenuMaster();
  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));
  const location = useLocation();
  const {
    activeRoomId,
    isMinimized,
    minimizeMeeting,
    maximizeMeeting,
    closeMeeting
  } = useMeeting();

  useEffect(() => {
    handlerDrawerOpen(!downLG);
  }, [downLG]);

  if (menuMasterLoading) return <Loader />;

  return (
    <AccessControlProvider>
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden', position: 'relative' }}>
      <ScrollTop />
      <GlobalMeetingAlert />

      {/* ── Full-width Header ── */}
      <Header />

      {/* ── Body: sidebar + content ── */}
      <Box sx={{ display: 'flex', flex: 1, overflow: 'hidden', mt: `${HEADER_HEIGHT}px` }}>

        {/* ── Sidebar ── */}
        <Sidebar />

        {/* ── Main content ── */}
        <Box
          component="main"
          sx={{
            flex: 1,
            overflowY: 'auto',
            pt: { xs: 1, sm: 1.25 },
            px: { xs: 2, sm: 3 },
            pb: { xs: 2, sm: 3 },
            minWidth: 0
          }}
        >
          <AccessViewGuard>
            <Outlet />
          </AccessViewGuard>
          <Footer />
        </Box>
      </Box>

      {/* ── Active Persistent Meeting (Full Screen Overlay OR Minimized PiP Card) ── */}
      {activeRoomId && (
        <MeetingRoom
          roomId={activeRoomId}
          isMinimized={isMinimized}
          onMinimize={minimizeMeeting}
          onMaximize={maximizeMeeting}
          onClose={closeMeeting}
        />
      )}
    </Box>
    </AccessControlProvider>
  );
}
